import {useEffect} from 'react';

import {useAdfoxStore} from '@shared/Ads/Yandex/store';

export const useAwakenController = (enabled = true) => {
  const {setAdFoxAds} = useAdfoxStore().adFoxState;
  useEffect(() => {
    if (!enabled) {
      return;
    }
    setAdFoxAds(true);
  }, [enabled, setAdFoxAds]);
};
